import find from "lodash/find";
import { SelectionPhoto, SelectionState } from "../../types/selection/selection";

class PhotoNotFoundError extends Error {}

export function findPhoto(photoKey: string, selection: SelectionState): SelectionPhoto {
  const photo = find(selection.photos, ({ key }) => key === photoKey);

  if (!photo) {
    throw new PhotoNotFoundError(`Photo not found for key "${photoKey}"`);
  }

  return photo;
}

export function isPhotoInPicturesList(
  selectionPhoto: SelectionPhoto,
  photoList: Array<{ key: string; providerRef: string }>
): boolean {
  return !!photoList.find(
    (photoKeys) =>
      photoKeys.providerRef === selectionPhoto.providerRef || photoKeys.key === selectionPhoto.key
  );
}
